export default "__VITE_ASSET__CHsml8qk__"